// Shared client/server feature components, reusable across all Mentora
// storefront apps. Storefront-specific values (e.g. price formatting) are
// injected by the consuming app via props so these stay storefront-agnostic.

// Admin
export { AdminSettingsPanel, type AdminSettingsPanelActions, type AdminSettingsPanelProps } from './lib/admin/admin-settings-panel'
export { StoreAdminsPanel, type StoreAdminsPanelActions, type StoreAdminsPanelProps } from './lib/admin/store-admins-panel'
export type { StoreAdminsPanelRole, StoreAdminsPanelUser } from './lib/admin/store-user-row'
// Chrome
export { HeaderExploreLink } from './lib/chrome/header-explore-link'
export { NotificationBell, type NotificationBellProps } from './lib/chrome/notification-bell'
export { OrgSelector, type OrgSelectorActions, type OrgSelectorProps } from './lib/chrome/org-selector'
export { ThemeToggle } from './lib/chrome/theme-toggle'
// Course authoring & stats
export { CourseTabs } from './lib/course-authoring/course-tabs'
export { CourseThumbnailUpload } from './lib/course-authoring/course-thumbnail-upload'
export { LessonVideoUploader, type LessonVideoUploaderActions, type LessonVideoUploaderProps } from './lib/course-authoring/lesson-video-uploader'
export { VipListPanel, type VipListPanelActions, type VipListPanelProps } from './lib/course-authoring/vip-list-panel'
export { PerLessonProgressTable } from './lib/course-stats/per-lesson-progress-table'
// Dashboard widgets
export { DashboardFilters } from './lib/dashboard/dashboard-filters'
export { NetVolumeCard } from './lib/dashboard/net-volume-card'
export { RecentSalesTable } from './lib/dashboard/recent-sales-table'
export { RefundsCouponsPanel } from './lib/dashboard/refunds-coupons-panel'
export { RevenueChart } from './lib/dashboard/revenue-chart'
export { RevenueShareBars, type RevenueShareRow } from './lib/dashboard/revenue-share-bars'
export { SalesChart } from './lib/dashboard/sales-chart'
export { TopCoursesTable } from './lib/dashboard/top-courses-table'
// Explore filters
export {
  ExploreFilterSidebar,
  ExploreSortChips,
} from './lib/explore/explore-controls'

export {
  type CatalogCourse,
  compareExploreCourses,
  EXPLORE_LEVELS,
  EXPLORE_PRICES,
  EXPLORE_SORTS,
  type ExploreFilters,
  type ExploreLevel,
  type ExplorePrice,
  type ExploreSort,
  matchesExploreFilters,
  parseExploreSearchParams,
} from './lib/explore/explore-params'

// Learn / course playback
export { LessonPlayer } from './lib/learn/lesson-player'

// Marketing
export { ContactForm } from './lib/marketing/contact-form'
export { LegalDocument } from './lib/marketing/legal-document'
export { VideoBackground } from './lib/marketing/video-background'

// Orders
export { OrdersPanel, type OrdersPanelProps } from './lib/orders/orders-panel'
// Organizations
export { OrganizationPanel, type OrganizationPanelActions, type OrganizationPanelProps } from './lib/organizations/organization-panel'
export { OrganizationsPanel, type OrganizationsPanelActions, type OrganizationsPanelProps } from './lib/organizations/organizations-panel'
export type { PriceFormatter } from './lib/price-formatter'
// Profile
export { AvatarUpload } from './lib/profile/avatar-upload'
// Reviews
export { ReviewForm, type SubmitReview } from './lib/reviews/review-form'

export { ReviewSection } from './lib/reviews/review-section'
export { StarRating } from './lib/reviews/star-rating'
// Settings
export {
  type CouponInput,
  type OrgSettings,
  type SettingsActions,
  SettingsPanel,
  type SettingsPanelProps,
  type SettingsTab,
} from './lib/settings/settings-panel'
// Transactions
export { type CancelMembershipAction } from './lib/transactions/membership-actions-card'
export { MembershipDetailsPanel } from './lib/transactions/membership-details-panel'
export { type TransactionActions } from './lib/transactions/transaction-actions-card'
export { TransactionDetailsLoader } from './lib/transactions/transaction-details-loader'
export { TransactionDetailsPanel } from './lib/transactions/transaction-details-panel'
export { TransactionsTable } from './lib/transactions/transactions-table'
// Video upload
export { useUploadFailureMessage } from './lib/video-upload/use-upload-failure-message'
